<template>
<svg viewBox="0 0 16 16" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-line-greaterThan`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M3.42088 3.15824C3.60153 2.83871 4.00743 2.72583 4.32713 2.90629L12.3281 7.42289C12.5366 7.54089 12.666 7.76235 12.666 8.00199C12.6659 8.24162 12.5367 8.46318 12.3281 8.58109L4.32713 13.0967C4.00734 13.2772 3.60146 13.1645 3.42088 12.8448C3.24038 12.525 3.35307 12.1191 3.67284 11.9385L10.6474 8.00102L3.67284 4.06449C3.35316 3.8839 3.24039 3.47801 3.42088 3.15824Z"/></svg>
</template>
<script>

export default {
  name: 'IconLineGreaterThan',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
